import axios from '../../axios';

const service = {
  async getAllEvents(params) {
    return axios({
      method: 'get',
      url: '/events',
      params: params
    });
  },

  async getEventById(id) {
    return axios({
      method: 'get',
      url: `/events/${id}`
    });
  },

  async createNewEvent(payload) {
    return axios({
      method: 'post',
      url: '/events',
      data: payload
    });
  },

  async deleteEvent(id, queryParams = {}) {
    return axios({
      method: 'delete',
      url: `/events/${id}`,
      params: queryParams
    });
  },

  async updateEvent(id, payload) {
    return axios({
      method: 'put',
      url: `/events/${id}`,
      data: payload
    });
  },

  async acceptEvent(id) {
    return axios({
      method: 'post',
      url: `/events/${id}/accept`
    });
  },

  async declineEvent(id) {
    return axios({
      method: 'post',
      url: `/events/${id}/decline`
    });
  }
};

export default service;
